export const chat_check = () => (
  <>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m16 9-5.5 5L8 11.727"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 12a9 9 0 0 1-9 9H3s1.125-1.08 2.659-2.613A9 9 0 1 1 21 12"
    />
  </>
);
